const ssoUrl = process.env.REACT_APP_SSO_URL || 'https://oa-sso.wsk.gmbh';
const mainApiUrl = (process.env.REACT_APP_API_URL || 'http://localhost:8000').replace(/\/api\/?$/, '');

function authHeaders() {
    return { Authorization: `Bearer ${localStorage.getItem('token')}` };
}

async function ssoDelete(companyId: number): Promise<void> {
    const res = await fetch(`${ssoUrl}/api/companies/${companyId}`, {
        method: 'DELETE',
        headers: authHeaders(),
    });
    if (!res.ok) {
        const body = await res.json().catch(() => ({}));
        throw new Error(
            (body.error || body['hydra:description'] || `SSO-Löschung fehlgeschlagen (HTTP ${res.status})`) +
            ' — Vorgang kann gefahrlos erneut ausgeführt werden.'
        );
    }
}

// Reihenfolge ist Pflicht: erst API-Purge (Demo-Guard braucht den Mandanten
// noch im SSO), dann SSO-Delete. Der Purge ist idempotent — Retry ist gefahrlos.
export async function hardDeleteDemoTenant(companyId: number): Promise<void> {
    const purgeRes = await fetch(`${mainApiUrl}/api/operator/purge-tenant/${companyId}`, {
        method: 'DELETE',
        headers: authHeaders(),
    });
    if (!purgeRes.ok) {
        const body = await purgeRes.json().catch(() => ({}));
        throw new Error(body.error || `API-Purge fehlgeschlagen (HTTP ${purgeRes.status})`);
    }

    await ssoDelete(companyId);
}

export async function softDeleteTenant(companyId: number): Promise<void> {
    await ssoDelete(companyId);
}
